// extracted by mini-css-extract-plugin
export var checkboxWrapper = "Checkbox-module--checkboxWrapper--PTwfw";
export var inputWrapper = "Checkbox-module--inputWrapper--tSoNW";
export var input = "Checkbox-module--input--+09fx";
export var box = "Checkbox-module--box--nuaX-";
export var md = "Checkbox-module--md--bButf";
export var boxTransparent = "Checkbox-module--boxTransparent--gZISk";
export var label = "Checkbox-module--label--FjhGa";